export default ({
  namespaced: true,
  state: {
    view: 'stopWatch',
    // httpDB usado para manipular o banco de dados, pois geralmente o stopwatch sava uma vez no banco e nas outras abas abertas apenas abre ou fecha o tempo não precisanod salvar no banco
    // storeOnly usado para apenas atualizar o store, pois em algumas atualizações como reset, não deve passar pelas validações no watch do stopWatch
    defaultValues: {id: '', task_id: '', begin: '', end: '', note: '', id_text: '', active: false, top_id: '', user_id: '', duration: '', user: '', httpDB: false},
    values: {id: '', task_id: '', begin: '', end: '', note: '', id_text: '', active: false, top_id: '', user_id: '', duration: '', user: '', httpDB: false}
  },
  getters: {
    values: state => {
      return state.values
    }
  },
  mutations: {
    change_values (state, payload) {
      // Passado o httpDB e como false, pois quando ele não for inserido tem que setar false para não ficar true e nas proximas interações considerar ele como true
      Object.assign(state.values, {httpDB: false}, payload)
    },
    reset_values (state) {
      Object.assign(state.values, state.defaultValues)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/stopWatch.js